import { format, parseJSON } from 'date-fns';

import { DATE_FORMAT } from 'common/constants';

import { cellValue } from 'commonComponents/MaterialTable';
import { TableRow } from 'commonComponents/TableRow';

import type { UserDetails as UserDetailsType } from 'api/users';

const ROW_DATA_MAPPER = [
    {
        title: 'Username',
        accessor: 'username',
    },
    {
        title: 'Full Name',
        accessor: 'full_name',
    },
    {
        title: 'Email address',
        accessor: 'email',
    },
    {
        title: 'Products',
        accessor: details => details.products?.map(p => p.name).join(', ') || '',
    },
    {
        title: 'Company',
        accessor: 'company',
    },
    {
        title: 'Country',
        accessor: 'country',
    },
    {
        title: 'City',
        accessor: 'city',
    },
    {
        title: 'Phone Number',
        accessor: 'phone_number',
    },
    {
        title: 'Default Owner ID',
        accessor: 'owner_id',
    },
    {
        title: 'Comment',
        accessor: 'comment',
    },
    {
        title: 'Joined',
        accessor: details => details.date_joined && format(parseJSON(details.date_joined), DATE_FORMAT),
    },
    {
        title: 'User Role(s)',
        accessor: details => details.groups.join(', '),
    },
    { title: 'Internal', accessor: 'is_internal' },
    { title: 'Active', accessor: 'is_active' },
];

type UserDetailsRowsProps = {
    user: UserDetailsType;
};

export function UserDetailsRows({ user }: UserDetailsRowsProps) {
    return ROW_DATA_MAPPER.map(rowData => {
        const value = cellValue(user, rowData);
        return <TableRow key={`${rowData.title}: ${value}`} title={rowData.title} value={value} />;
    });
}
